<div class="challenge-sections">
  <div
    *ngFor="let section of sections"
    class="challenge-sections--item"
    [class.expanded]="isSectionExpanded(section.id)"
    [id]="section.id"
  >
    <div class="challenge-sections--header" (click)="toggleSection(section.id)">
      <span class="challenge-sections--label">{{ section.label }}</span>
      <div class="challenge-sections--actions">
        <svg
          class="challenge-sections--arrow"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14M12 5l7 7-7 7"></path>
        </svg>
      </div>
    </div>
    <div class="challenge-sections--body" *ngIf="isSectionExpanded(section.id)">
      <div class="challenge-sections--content-text" [innerHTML]="section.content"></div>
    </div>
  </div>
</div>


